export var getLocation = function getLocation() {
  var _window$location = window.location,
    hostname = _window$location.hostname,
    origin = _window$location.origin,
    search = _window$location.search,
    reload = _window$location.reload;
  return {
    hostname: hostname,
    origin: origin,
    search: search,
    reload: reload
  };
};
//# sourceMappingURL=Location.js.map